import { c as _c } from "react/compiler-runtime";
import type { ApiWave } from "@/generated/models/ApiWave";
import { WAVE_IDENTITY_DUPLICATES_COPY, WAVE_IDENTITY_WHO_CAN_BE_SUBMITTED_COPY } from "@/helpers/waves/wave-submission-strategy.helpers";
interface WaveIdentitySubmissionSpecsProps {
  readonly wave: ApiWave;
  readonly useRing?: boolean | undefined;
}
function WaveIdentitySubmissionSpecsRow(t0) {
  const $ = _c(7);
  const {
    label,
    value
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <span className="tw-font-medium tw-text-iron-400">{label}</span>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== value) {
    t2 = <span className="tw-flex-1 tw-text-right tw-font-medium tw-text-iron-200">{value}</span>;
    $[2] = value;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="tw-group tw-flex tw-w-full tw-items-start tw-justify-between tw-gap-2 tw-text-sm">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
export default function WaveIdentitySubmissionSpecs(t0) {
  const $ = _c(14);
  const {
    wave,
    useRing: t1
  } = t0;
  const useRing = t1 === undefined ? true : t1;
  const submissionStrategy = wave.participation.submission_strategy;
  if (!submissionStrategy) {
    return null;
  }
  const ringClasses = useRing ? "tw-ring-1 tw-ring-inset tw-ring-iron-800 tw-rounded-xl" : "";
  const borderClasses = useRing ? "" : "tw-border-x-0 tw-border-b-0 tw-border-t tw-border-solid tw-border-iron-800";
  const t2 = `tw-relative tw-overflow-auto tw-bg-iron-950 ${ringClasses}`;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="tw-flex tw-items-center tw-justify-between tw-px-4 tw-pt-3"><p className="tw-mb-0 tw-text-base tw-font-semibold tw-tracking-tight tw-text-iron-200">Identity submissions</p></div>;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const t4 = WAVE_IDENTITY_WHO_CAN_BE_SUBMITTED_COPY[submissionStrategy.config.who_can_be_submitted];
  let t5;
  if ($[1] !== t4.summary) {
    t5 = <WaveIdentitySubmissionSpecsRow label="Eligible identities" value={t4.summary} />;
    $[1] = t4.summary;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const t6 = WAVE_IDENTITY_DUPLICATES_COPY[submissionStrategy.config.duplicates];
  let t7;
  if ($[3] !== t6.summary) {
    t7 = <WaveIdentitySubmissionSpecsRow label="Repeat submissions" value={t6.summary} />;
    $[3] = t6.summary;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] !== t5 || $[6] !== t7) {
    t8 = <div className="tw-pb-4">{t3}<div className="tw-mt-2.5 tw-flex tw-flex-col tw-gap-2 tw-px-4">{t5}{t7}</div></div>;
    $[5] = t5;
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== t2 || $[9] !== t8) {
    t9 = <div className={t2}>{t8}</div>;
    $[8] = t2;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== borderClasses || $[12] !== t9) {
    t10 = <div className={borderClasses}>{t9}</div>;
    $[11] = borderClasses;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  return t10;
}